import { DocumentService } from '../../services/document-service';

/**
 * @typedef {import('../../enums/document-type').DocumentTypeEnum} DocumentTypeEnum
 */

/**
 * @param {DocumentTypeEnum} documentType
 * @param {string | number} [templateId]
 * @returns {string}
 */
const getDownloadQueryParams = (documentType, templateId) => {
  const downloadParam = '?download=1';
  return templateId ? `${downloadParam}&${documentType.templateIdQueryParameterName}=${templateId}` : downloadParam;
};

/**
 * @param {string} providedDownloadUrl - ideally this is provided from an async printing job in v3queue service to avoid doing the work synchronously in webv3
 * @param {DocumentTypeEnum} documentType
 * @param {string[]} documentIds
 * @param {string | number} [templateId]
 * @returns {object[]}
 */
export const downloadDocument = (providedDownloadUrl, documentType, documentIds, templateId) => {
  const downloadDocumentActions = DocumentService.getDownloadDocumentActions(documentType, documentIds);
  const url = providedDownloadUrl || `${documentType.apiDownloadPath}/${documentIds}${getDownloadQueryParams(documentType, templateId)}`;

  DocumentService.downloadFile(url);

  return downloadDocumentActions;
};
